

import ScrollListener from './ScrollListener';
const $ = jQuery;
let ScrollFadeGallery = function(args){
	this.args = args;
	this.init();
}

ScrollFadeGallery.prototype = {
	init: function(){
		this.container = $(this.args.sel);
		var SFG = this;
		var items = [];
		this.container.find('.screen').each(function(v,i){
			var ind = $(this).index()+1;
			if ($(this).find('> figcaption').length){
				if ($(this).find('> div.background-image.sfg-caption.mask-dark'));
				$(this).prepend('<div class="mask-dark card-caption top left background-image sfg-caption"></div>');
				$(this).find('> figcaption').addClass('sfg-caption');
				items.push({sel:'.screen:nth-child('+ind+')', endOffset:1});
				items.push({sel:'.screen:nth-child('+ind+') .sfg-caption', endOffset:0});
			}
			else {
				items.push({sel:'.screen:nth-child('+ind+')', endOffset:0});
			}
		});
		this.items = items;
		var animations = [];
		for (var i=1; i<=items.length; i++){
			//Counting progress starts when container top matches window bottom and 
			// ends when container bottom matches window top
			// We need to add 2 extra screen in order to start animation when 
			// the container fills the viewport.
			var start = i==1?0:Math.floor(i*100/(this.items.length+2))-5;
			var endOffset = this.items[i-1].endOffset +1;
			var end = i+endOffset-1==this.items.length?101:Math.floor((i+endOffset)*100/(this.items.length+2))+5;

			animations.push({
				sel: items[i-1].sel,
				start: start,
				end: end,
				fn: 'fadeInOut',
				param: 1000
			});
		}
		
		this.scrollListener = new ScrollListener({
			sel: SFG.args.sel,
			slidesHeight: (SFG.items.length * 150)+'vh',
			animations: [
			{
				slide: 1,
				animations: animations
			}
			] 
		});
	}
}
window.ScrollFadeGallery = ScrollFadeGallery;

export default ScrollFadeGallery;